export interface Country {
  name: string;
  callingCode: string;
  isoCode: string;
}

export const COUNTRIES: Country[] = [
  { name: "Afghanistan", callingCode: "93", isoCode: "AF" },
  { name: "Albania", callingCode: "355", isoCode: "AL" },
  { name: "Algeria", callingCode: "213", isoCode: "DZ" },
  { name: "American Samoa", callingCode: "1-684", isoCode: "AS" },
  { name: "Andorra", callingCode: "376", isoCode: "AD" },
  { name: "Angola", callingCode: "244", isoCode: "AO" },
  { name: "Anguilla", callingCode: "1-264", isoCode: "AI" },
  { name: "Antarctica", callingCode: "672", isoCode: "AQ" },
  { name: "Antigua and Barbuda", callingCode: "1-268", isoCode: "AG" },
  { name: "Argentina", callingCode: "54", isoCode: "AR" },
  { name: "Armenia", callingCode: "374", isoCode: "AM" },
  { name: "Aruba", callingCode: "297", isoCode: "AW" },
  { name: "Australia", callingCode: "61", isoCode: "AU" },
  { name: "Austria", callingCode: "43", isoCode: "AT" },
  { name: "Azerbaijan", callingCode: "994", isoCode: "AZ" },
  { name: "Bahamas", callingCode: "1-242", isoCode: "BS" },
  { name: "Bahrain", callingCode: "973", isoCode: "BH" },
  { name: "Bangladesh", callingCode: "880", isoCode: "BD" },
  { name: "Barbados", callingCode: "1-246", isoCode: "BB" },
  { name: "Belarus", callingCode: "375", isoCode: "BY" },
  { name: "Belgium", callingCode: "32", isoCode: "BE" },
  { name: "Belize", callingCode: "501", isoCode: "BZ" },
  { name: "Benin", callingCode: "229", isoCode: "BJ" },
  { name: "Bermuda", callingCode: "1-441", isoCode: "BM" },
  { name: "Bhutan", callingCode: "975", isoCode: "BT" },
  { name: "Bolivia", callingCode: "591", isoCode: "BO" },
  { name: "Bosnia and Herzegovina", callingCode: "387", isoCode: "BA" },
  { name: "Botswana", callingCode: "267", isoCode: "BW" },
  { name: "Brazil", callingCode: "55", isoCode: "BR" },
  { name: "British Indian Ocean Territory", callingCode: "246", isoCode: "IO" },
  { name: "British Virgin Islands", callingCode: "1-284", isoCode: "VG" },
  { name: "Brunei", callingCode: "673", isoCode: "BN" },
  { name: "Bulgaria", callingCode: "359", isoCode: "BG" },
  { name: "Burkina Faso", callingCode: "226", isoCode: "BF" },
  { name: "Burundi", callingCode: "257", isoCode: "BI" },
  { name: "Cambodia", callingCode: "855", isoCode: "KH" },
  { name: "Cameroon", callingCode: "237", isoCode: "CM" },
  { name: "Canada", callingCode: "1", isoCode: "CA" },
  { name: "Cape Verde", callingCode: "238", isoCode: "CV" },
  { name: "Cayman Islands", callingCode: "1-345", isoCode: "KY" },
  { name: "Central African Republic", callingCode: "236", isoCode: "CF" },
  { name: "Chad", callingCode: "235", isoCode: "TD" },
  { name: "Chile", callingCode: "56", isoCode: "CL" },
  { name: "China", callingCode: "86", isoCode: "CN" },
  { name: "Christmas Island", callingCode: "61", isoCode: "CX" },
  { name: "Cocos Islands", callingCode: "61", isoCode: "CC" },
  { name: "Colombia", callingCode: "57", isoCode: "CO" },
  { name: "Comoros", callingCode: "269", isoCode: "KM" },
  { name: "Cook Islands", callingCode: "682", isoCode: "CK" },
  { name: "Costa Rica", callingCode: "506", isoCode: "CR" },
  { name: "Croatia", callingCode: "385", isoCode: "HR" },
  { name: "Cuba", callingCode: "53", isoCode: "CU" },
  { name: "Curacao", callingCode: "599", isoCode: "CW" },
  { name: "Cyprus", callingCode: "357", isoCode: "CY" },
  { name: "Czech Republic", callingCode: "420", isoCode: "CZ" },
  {
    name: "Democratic Republic of the Congo",
    callingCode: "243",
    isoCode: "CD",
  },
  { name: "Denmark", callingCode: "45", isoCode: "DK" },
  { name: "Djibouti", callingCode: "253", isoCode: "DJ" },
  { name: "Dominica", callingCode: "1-767", isoCode: "DM" },
  {
    name: "Dominican Republic",
    callingCode: "1-809",
    isoCode: "DO",
  },
  { name: "East Timor", callingCode: "670", isoCode: "TL" },
  { name: "Ecuador", callingCode: "593", isoCode: "EC" },
  { name: "Egypt", callingCode: "20", isoCode: "EG" },
  { name: "El Salvador", callingCode: "503", isoCode: "SV" },
  { name: "Equatorial Guinea", callingCode: "240", isoCode: "GQ" },
  { name: "Eritrea", callingCode: "291", isoCode: "ER" },
  { name: "Estonia", callingCode: "372", isoCode: "EE" },
  { name: "Ethiopia", callingCode: "251", isoCode: "ET" },
  { name: "Falkland Islands", callingCode: "500", isoCode: "FK" },
  { name: "Faroe Islands", callingCode: "298", isoCode: "FO" },
  { name: "Fiji", callingCode: "679", isoCode: "FJ" },
  { name: "Finland", callingCode: "358", isoCode: "FI" },
  { name: "France", callingCode: "33", isoCode: "FR" },
  { name: "French Polynesia", callingCode: "689", isoCode: "PF" },
  { name: "Gabon", callingCode: "241", isoCode: "GA" },
  { name: "Gambia", callingCode: "220", isoCode: "GM" },
  { name: "Georgia", callingCode: "995", isoCode: "GE" },
  { name: "Germany", callingCode: "49", isoCode: "DE" },
  { name: "Ghana", callingCode: "233", isoCode: "GH" },
  { name: "Gibraltar", callingCode: "350", isoCode: "GI" },
  { name: "Greece", callingCode: "30", isoCode: "GR" },
  { name: "Greenland", callingCode: "299", isoCode: "GL" },
  { name: "Grenada", callingCode: "1-473", isoCode: "GD" },
  { name: "Guam", callingCode: "1-671", isoCode: "GU" },
  { name: "Guatemala", callingCode: "502", isoCode: "GT" },
  { name: "Guernsey", callingCode: "44-1481", isoCode: "GG" },
  { name: "Guinea", callingCode: "224", isoCode: "GN" },
  { name: "Guinea-Bissau", callingCode: "245", isoCode: "GW" },
  { name: "Guyana", callingCode: "592", isoCode: "GY" },
  { name: "Haiti", callingCode: "509", isoCode: "HT" },
  { name: "Honduras", callingCode: "504", isoCode: "HN" },
  { name: "Hong Kong", callingCode: "852", isoCode: "HK" },
  { name: "Hungary", callingCode: "36", isoCode: "HU" },
  { name: "Iceland", callingCode: "354", isoCode: "IS" },
  { name: "India", callingCode: "91", isoCode: "IN" },
  { name: "Indonesia", callingCode: "62", isoCode: "ID" },
  { name: "Iran", callingCode: "98", isoCode: "IR" },
  { name: "Iraq", callingCode: "964", isoCode: "IQ" },
  { name: "Ireland", callingCode: "353", isoCode: "IE" },
  { name: "Isle of Man", callingCode: "44-1624", isoCode: "IM" },
  { name: "Israel", callingCode: "972", isoCode: "IL" },
  { name: "Italy", callingCode: "39", isoCode: "IT" },
  { name: "Ivory Coast", callingCode: "225", isoCode: "CI" },
  { name: "Jamaica", callingCode: "1-876", isoCode: "JM" },
  { name: "Japan", callingCode: "81", isoCode: "JP" },
  { name: "Jersey", callingCode: "44-1534", isoCode: "JE" },
  { name: "Jordan", callingCode: "962", isoCode: "JO" },
  { name: "Kazakhstan", callingCode: "7", isoCode: "KZ" },
  { name: "Kenya", callingCode: "254", isoCode: "KE" },
  { name: "Kiribati", callingCode: "686", isoCode: "KI" },
  { name: "Kosovo", callingCode: "383", isoCode: "XK" },
  { name: "Kuwait", callingCode: "965", isoCode: "KW" },
  { name: "Kyrgyzstan", callingCode: "996", isoCode: "KG" },
  { name: "Laos", callingCode: "856", isoCode: "LA" },
  { name: "Latvia", callingCode: "371", isoCode: "LV" },
  { name: "Lebanon", callingCode: "961", isoCode: "LB" },
  { name: "Lesotho", callingCode: "266", isoCode: "LS" },
  { name: "Liberia", callingCode: "231", isoCode: "LR" },
  { name: "Libya", callingCode: "218", isoCode: "LY" },
  { name: "Liechtenstein", callingCode: "423", isoCode: "LI" },
  { name: "Lithuania", callingCode: "370", isoCode: "LT" },
  { name: "Luxembourg", callingCode: "352", isoCode: "LU" },
  { name: "Macao", callingCode: "853", isoCode: "MO" },
  { name: "Macedonia", callingCode: "389", isoCode: "MK" },
  { name: "Madagascar", callingCode: "261", isoCode: "MG" },
  { name: "Malawi", callingCode: "265", isoCode: "MW" },
  { name: "Malaysia", callingCode: "60", isoCode: "MY" },
  { name: "Maldives", callingCode: "960", isoCode: "MV" },
  { name: "Mali", callingCode: "223", isoCode: "ML" },
  { name: "Malta", callingCode: "356", isoCode: "MT" },
  { name: "Marshall Islands", callingCode: "692", isoCode: "MH" },
  { name: "Mauritania", callingCode: "222", isoCode: "MR" },
  { name: "Mauritius", callingCode: "230", isoCode: "MU" },
  { name: "Mayotte", callingCode: "262", isoCode: "YT" },
  { name: "Mexico", callingCode: "52", isoCode: "MX" },
  { name: "Micronesia", callingCode: "691", isoCode: "FM" },
  { name: "Moldova", callingCode: "373", isoCode: "MD" },
  { name: "Monaco", callingCode: "377", isoCode: "MC" },
  { name: "Mongolia", callingCode: "976", isoCode: "MN" },
  { name: "Montenegro", callingCode: "382", isoCode: "ME" },
  { name: "Montserrat", callingCode: "1-664", isoCode: "MS" },
  { name: "Morocco", callingCode: "212", isoCode: "MA" },
  { name: "Mozambique", callingCode: "258", isoCode: "MZ" },
  { name: "Myanmar", callingCode: "95", isoCode: "MM" },
  { name: "Namibia", callingCode: "264", isoCode: "NA" },
  { name: "Nauru", callingCode: "674", isoCode: "NR" },
  { name: "Nepal", callingCode: "977", isoCode: "NP" },
  { name: "Netherlands", callingCode: "31", isoCode: "NL" },
  { name: "Netherlands Antilles", callingCode: "599", isoCode: "AN" },
  { name: "New Caledonia", callingCode: "687", isoCode: "NC" },
  { name: "New Zealand", callingCode: "64", isoCode: "NZ" },
  { name: "Nicaragua", callingCode: "505", isoCode: "NI" },
  { name: "Niger", callingCode: "227", isoCode: "NE" },
  { name: "Nigeria", callingCode: "234", isoCode: "NG" },
  { name: "Niue", callingCode: "683", isoCode: "NU" },
  { name: "North Korea", callingCode: "850", isoCode: "KP" },
  { name: "Northern Mariana Islands", callingCode: "1-670", isoCode: "MP" },
  { name: "Norway", callingCode: "47", isoCode: "NO" },
  { name: "Oman", callingCode: "968", isoCode: "OM" },
  { name: "Pakistan", callingCode: "92", isoCode: "PK" },
  { name: "Palau", callingCode: "680", isoCode: "PW" },
  { name: "Palestine", callingCode: "970", isoCode: "PS" },
  { name: "Panama", callingCode: "507", isoCode: "PA" },
  { name: "Papua New Guinea", callingCode: "675", isoCode: "PG" },
  { name: "Paraguay", callingCode: "595", isoCode: "PY" },
  { name: "Peru", callingCode: "51", isoCode: "PE" },
  { name: "Philippines", callingCode: "63", isoCode: "PH" },
  { name: "Pitcairn", callingCode: "64", isoCode: "PN" },
  { name: "Poland", callingCode: "48", isoCode: "PL" },
  { name: "Portugal", callingCode: "351", isoCode: "PT" },
  { name: "Puerto Rico", callingCode: "1-787", isoCode: "PR" },
  { name: "Qatar", callingCode: "974", isoCode: "QA" },
  { name: "Republic of the Congo", callingCode: "242", isoCode: "CG" },
  { name: "Reunion", callingCode: "262", isoCode: "RE" },
  { name: "Romania", callingCode: "40", isoCode: "RO" },
  { name: "Russia", callingCode: "7", isoCode: "RU" },
  { name: "Rwanda", callingCode: "250", isoCode: "RW" },
  { name: "Saint Barthelemy", callingCode: "590", isoCode: "BL" },
  { name: "Saint Helena", callingCode: "290", isoCode: "SH" },
  { name: "Saint Kitts and Nevis", callingCode: "1-869", isoCode: "KN" },
  { name: "Saint Lucia", callingCode: "1-758", isoCode: "LC" },
  { name: "Saint Martin", callingCode: "590", isoCode: "MF" },
  { name: "Saint Pierre and Miquelon", callingCode: "508", isoCode: "PM" },
  {
    name: "Saint Vincent and the Grenadines",
    callingCode: "1-784",
    isoCode: "VC",
  },
  { name: "Samoa", callingCode: "685", isoCode: "WS" },
  { name: "San Marino", callingCode: "378", isoCode: "SM" },
  { name: "Sao Tome and Principe", callingCode: "239", isoCode: "ST" },
  { name: "Saudi Arabia", callingCode: "966", isoCode: "SA" },
  { name: "Senegal", callingCode: "221", isoCode: "SN" },
  { name: "Serbia", callingCode: "381", isoCode: "RS" },
  { name: "Seychelles", callingCode: "248", isoCode: "SC" },
  { name: "Sierra Leone", callingCode: "232", isoCode: "SL" },
  { name: "Singapore", callingCode: "65", isoCode: "SG" },
  { name: "Sint Maarten", callingCode: "1-721", isoCode: "SX" },
  { name: "Slovakia", callingCode: "421", isoCode: "SK" },
  { name: "Slovenia", callingCode: "386", isoCode: "SI" },
  { name: "Solomon Islands", callingCode: "677", isoCode: "SB" },
  { name: "Somalia", callingCode: "252", isoCode: "SO" },
  { name: "South Africa", callingCode: "27", isoCode: "ZA" },
  { name: "South Korea", callingCode: "82", isoCode: "KR" },
  { name: "South Sudan", callingCode: "211", isoCode: "SS" },
  { name: "Spain", callingCode: "34", isoCode: "ES" },
  { name: "Sri Lanka", callingCode: "94", isoCode: "LK" },
  { name: "Sudan", callingCode: "249", isoCode: "SD" },
  { name: "Suriname", callingCode: "597", isoCode: "SR" },
  { name: "Svalbard and Jan Mayen", callingCode: "47", isoCode: "SJ" },
  { name: "Swaziland", callingCode: "268", isoCode: "SZ" },
  { name: "Sweden", callingCode: "46", isoCode: "SE" },
  { name: "Switzerland", callingCode: "41", isoCode: "CH" },
  { name: "Syria", callingCode: "963", isoCode: "SY" },
  { name: "Taiwan", callingCode: "886", isoCode: "TW" },
  { name: "Tajikistan", callingCode: "992", isoCode: "TJ" },
  { name: "Tanzania", callingCode: "255", isoCode: "TZ" },
  { name: "Thailand", callingCode: "66", isoCode: "TH" },
  { name: "Togo", callingCode: "228", isoCode: "TG" },
  { name: "Tokelau", callingCode: "690", isoCode: "TK" },
  { name: "Tonga", callingCode: "676", isoCode: "TO" },
  { name: "Trinidad and Tobago", callingCode: "1-868", isoCode: "TT" },
  { name: "Tunisia", callingCode: "216", isoCode: "TN" },
  { name: "Turkey", callingCode: "90", isoCode: "TR" },
  { name: "Turkmenistan", callingCode: "993", isoCode: "TM" },
  { name: "Turks and Caicos Islands", callingCode: "1-649", isoCode: "TC" },
  { name: "Tuvalu", callingCode: "688", isoCode: "TV" },
  { name: "U.S. Virgin Islands", callingCode: "1-340", isoCode: "VI" },
  { name: "Uganda", callingCode: "256", isoCode: "UG" },
  { name: "Ukraine", callingCode: "380", isoCode: "UA" },
  { name: "United Arab Emirates", callingCode: "971", isoCode: "AE" },
  { name: "United Kingdom", callingCode: "44", isoCode: "GB" },
  { name: "United States", callingCode: "1", isoCode: "US" },
  { name: "Uruguay", callingCode: "598", isoCode: "UY" },
  { name: "Uzbekistan", callingCode: "998", isoCode: "UZ" },
  { name: "Vanuatu", callingCode: "678", isoCode: "VU" },
  { name: "Vatican", callingCode: "379", isoCode: "VA" },
  { name: "Venezuela", callingCode: "58", isoCode: "VE" },
  { name: "Vietnam", callingCode: "84", isoCode: "VN" },
  { name: "Wallis and Futuna", callingCode: "681", isoCode: "WF" },
  { name: "Western Sahara", callingCode: "212", isoCode: "EH" },
  { name: "Yemen", callingCode: "967", isoCode: "YE" },
  { name: "Zambia", callingCode: "260", isoCode: "ZM" },
  { name: "Zimbabwe", callingCode: "263", isoCode: "ZW" },
];

export type CountryCallingCode = {
  value: string;
  label: string;
  trueValue: string;
  prefix: string;
  country: string;
};

export const COUNTRIES_CALLING_CODES: CountryCallingCode[] = COUNTRIES.map((country) => {
  return {
    value: `${country.isoCode}-${country.callingCode}`,
    label: `${country.name} (+${country.callingCode})`,
    trueValue: country.callingCode,
    prefix: country.callingCode,
    country: country.name,
  };
});

export const COUNTRIES_ISO_CODES = COUNTRIES.map((country) => {
  return {
    value: country.isoCode,
    label: country.name,
  };
});
export const LANGUAGES = [
  // English
  { value: "en-US", label: "English (United States)" },
  { value: "en-GB", label: "English (United Kingdom)" },
  // { value: "en-CA", label: "English (Canada)" },
  // { value: "en-AU", label: "English (Australia)" },

  // Portuguese
  { value: "pt-BR", label: "Português (Brasil)" },

  // Spanish
  // { value: "es-ES", label: "Spanish (España)" },
  { value: "es-AR", label: "Spanish (Argentina)" },
  { value: "es-CL", label: "Spanish (Chile)" },
  { value: "es-CO", label: "Spanish (Colombia)" },
  // { value: "es-PE", label: "Spanish (Perú)" },
  // { value: "es-MX", label: "Spanish (México)" },
  { value: "es-EC", label: "Spanish (Ecuador)" },
  { value: "es-UY", label: "Spanish (Uruguay)" },
  { value: "es-PY", label: "Spanish (Paraguay)" },
  { value: "es-BO", label: "Spanish (Bolivia)" },
  { value: "es-DO", label: "Spanish (Dominican Republic)" },
];
export const BANKS_BY_COUNTRY: Record<string, { value: string; label: string }[]> = {
  AR: [
    { value: "BANCO DE LA NACION AR", label: "BANCO DE LA NACION AR" },
    {
      value: "BANCO DE LA PROVINCIA DE BUENOS AIRES",
      label: "BANCO DE LA PROVINCIA DE BUENOS AIRES",
    },
    {
      value: "BANCO DE LA PROVINCIA DE CORDOBA S.A.",
      label: "BANCO DE LA PROVINCIA DE CORDOBA S.A.",
    },
    { value: "BANCO DE LA CIUDAD DE BUENOS AIRES", label: "BANCO DE LA CIUDAD DE BUENOS AIRES" },
    { value: "BANCO MUNICIPAL DE ROSARIO", label: "BANCO MUNICIPAL DE ROSARIO" },
    { value: "BANCO DEL CHUBUT S.A.", label: "BANCO DEL CHUBUT S.A." },
    {
      value: "BANCO DE LA PAMPA SOCIEDAD DE ECONOMÍA M",
      label: "BANCO DE LA PAMPA SOCIEDAD DE ECONOMÍA M",
    },
    { value: "BANCO DE CORRIENTES S.A.", label: "BANCO DE CORRIENTES S.A." },
    {
      value: "BANCO PROVINCIA DEL NEUQUÉN SOCIEDAD ANÓ",
      label: "BANCO PROVINCIA DEL NEUQUÉN SOCIEDAD ANÓ",
    },
    { value: "BANCO PROVINCIA DE TIERRA DEL FUEGO", label: "BANCO PROVINCIA DE TIERRA DEL FUEGO" },
    {
      value: "BANCO DE INVERSION Y COMERCIO EXTERIOR S",
      label: "BANCO DE INVERSION Y COMERCIO EXTERIOR S",
    },
    {
      value: "BANCO RIOJA SOCIEDAD ANONIMA UNIPERSONAL",
      label: "BANCO RIOJA SOCIEDAD ANONIMA UNIPERSONAL",
    },
    { value: "NUEVO BANCO DEL CHACO S. A.", label: "NUEVO BANCO DEL CHACO S. A." },
    {
      value: "BANCO DE GALICIA Y BUENOS AIRES S.A.",
      label: "BANCO DE GALICIA Y BUENOS AIRES S.A.",
    },
    {
      value: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      label: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
    },
    { value: "CITIBANK N.A.", label: "CITIBANK N.A." },
    { value: "BBVA BANCO FRANCES S.A.", label: "BBVA BANCO FRANCES S.A." },
    {
      value: "THE BANK OF TOKYO-MITSUBISHI UFJ, LTD.",
      label: "THE BANK OF TOKYO-MITSUBISHI UFJ, LTD.",
    },
    { value: "BANCO SUPERVIELLE S.A.", label: "BANCO SUPERVIELLE S.A." },
    { value: "BANCO PATAGONIA S.A.", label: "BANCO PATAGONIA S.A." },
    { value: "BANCO HIPOTECARIO S.A.", label: "BANCO HIPOTECARIO S.A." },
    { value: "BANCO DE SAN JUAN S.A.", label: "BANCO DE SAN JUAN S.A." },
    { value: "BANCO DEL TUCUMAN S.A.", label: "BANCO DEL TUCUMAN S.A." },
    { value: "BANCO SANTANDER RIO S.A.", label: "BANCO SANTANDER RIO S.A." },
    { value: "BANCO DE SANTA CRUZ S.A.", label: "BANCO DE SANTA CRUZ S.A." },
    { value: "BANCO INTERFINANZAS S.A.", label: "BANCO INTERFINANZAS S.A." },
    { value: "HSBC BANK AR S.A.", label: "HSBC BANK AR S.A." },
    {
      value: "JPMORGAN CHASE BANK, NATIONAL ASSOCIATIO",
      label: "JPMORGAN CHASE BANK, NATIONAL ASSOCIATIO",
    },
    {
      value: "BANCO CREDICOOP COOPERATIVO LIMITADO",
      label: "BANCO CREDICOOP COOPERATIVO LIMITADO",
    },
    { value: "BANCO DE VALORES S.A.", label: "BANCO DE VALORES S.A." },
    { value: "BANCO ROELA S.A.", label: "BANCO ROELA S.A." },
    { value: "BANCO MARIVA S.A.", label: "BANCO MARIVA S.A." },
    { value: "BANCO ITAU AR S.A.", label: "BANCO ITAU AR S.A." },
    {
      value: "BANK OF AMERICA, NATIONAL ASSOCIATION",
      label: "BANK OF AMERICA, NATIONAL ASSOCIATION",
    },
    { value: "BNP PARIBAS", label: "BNP PARIBAS" },
    {
      value: "BANCO DE LA REPUBLICA ORIENTAL DEL URUGU",
      label: "BANCO DE LA REPUBLICA ORIENTAL DEL URUGU",
    },
    { value: "BANCO SAENZ S.A.", label: "BANCO SAENZ S.A." },
    { value: "BANCO MERIDIAN S.A.", label: "BANCO MERIDIAN S.A." },
    { value: "BANCO MACRO S.A.", label: "BANCO MACRO S.A." },
    { value: "BANCO COMAFI SOCIEDAD ANONIMA", label: "BANCO COMAFI SOCIEDAD ANONIMA" },
    { value: "BANCO PIANO S.A.", label: "BANCO PIANO S.A." },
    { value: "BANCO JULIO SOCIEDAD ANONIMA", label: "BANCO JULIO SOCIEDAD ANONIMA" },
    { value: "BANCO DEL SOL S.A.", label: "BANCO DEL SOL S.A." },
    { value: "BANCO VOII S.A.", label: "BANCO VOII S.A." },
    { value: "BANCO DE FORMOSA S.A.", label: "BANCO DE FORMOSA S.A." },
    { value: "BANCO CMF S.A.", label: "BANCO CMF S.A." },
    { value: "BANCO DE SANTIAGO DEL ESTERO S.A.", label: "BANCO DE SANTIAGO DEL ESTERO S.A." },
    { value: "BANCO INDUSTRIAL S.A.", label: "BANCO INDUSTRIAL S.A." },
    {
      value: "NUEVO BANCO DE SANTA FE SOCIEDAD ANONIMA",
      label: "NUEVO BANCO DE SANTA FE SOCIEDAD ANONIMA",
    },
    { value: "BANCO CETELEM AR S.A.", label: "BANCO CETELEM AR S.A." },
    { value: "BANCO DE SERVICIOS FINANCIEROS S.A.", label: "BANCO DE SERVICIOS FINANCIEROS S.A." },
    { value: "BANCO BRADESCO AR S.A.U.", label: "BANCO BRADESCO AR S.A.U." },
    {
      value: "BANCO DE SERVICIOS Y TRANSACCIONES S.A.",
      label: "BANCO DE SERVICIOS Y TRANSACCIONES S.A.",
    },
    { value: "RCI BANQUE S.A.", label: "RCI BANQUE S.A." },
    {
      value: "BACS BANCO DE CREDITO Y SECURITIZACION S",
      label: "BACS BANCO DE CREDITO Y SECURITIZACION S",
    },
    { value: "BANCO MASVENTAS S.A.", label: "BANCO MASVENTAS S.A." },
    { value: "WILOBANK S.A.", label: "WILOBANK S.A." },
    { value: "NUEVO BANCO DE ENTRE RÍOS S.A.", label: "NUEVO BANCO DE ENTRE RÍOS S.A." },
    { value: "BANCO COLUMBIA S.A.", label: "BANCO COLUMBIA S.A." },
    { value: "BANCO BICA S.A.", label: "BANCO BICA S.A." },
    { value: "BANCO COINAG S.A.", label: "BANCO COINAG S.A." },
    { value: "BANCO DE COMERCIO S.A.", label: "BANCO DE COMERCIO S.A." },
  ],
  BR: [
    { value: "Banco do Brazil", label: "Banco do Brazil" },
    { value: "Banco do Nordeste", label: "Banco do Nordeste" },
    { value: "Banco Itaú", label: "Banco Itaú" },
    { value: "Banco Safra", label: "Banco Safra" },
    { value: "Banco Santander Brasil", label: "Banco Santander Brasil" },
    { value: "Banco Sofisa", label: "Banco Sofisa" },
    { value: "Banrisul", label: "Banrisul" },
    { value: "Bradesco", label: "Bradesco" },
    { value: "Unibanco", label: "Unibanco" },
    { value: "HSBC Brazil", label: "HSBC Brazil" },
    { value: "Citibank Brazil", label: "Citibank Brazil" },
  ],
  CL: [
    { value: "BANCO DE CHILE-EDWARDS", label: "BANCO DE CHILE-EDWARDS" },
    { value: "BANCO BICE", label: "BANCO BICE" },
    { value: "BANCO CONSORCIO", label: "BANCO CONSORCIO" },
    { value: "BANCO DEL ESTADO DE CHILE", label: "BANCO DEL ESTADO DE CHILE" },
    { value: "BANCO DO BRASIL S.A.", label: "BANCO DO BRASIL S.A." },
    { value: "BANCO FALABELLA", label: "BANCO FALABELLA" },
    { value: "BANCO INTERNACIONAL", label: "BANCO INTERNACIONAL" },
    { value: "BANCO PARIS", label: "BANCO PARIS" },
    { value: "BANCO RIPLEY", label: "BANCO RIPLEY" },
    { value: "BANCO SANTANDER", label: "BANCO SANTANDER" },
    { value: "BANCO SECURITY", label: "BANCO SECURITY" },
    { value: "BBVA (BCO BILBAO VIZCAYA ARG)", label: "BBVA (BCO BILBAO VIZCAYA ARG)" },
    { value: "BCI (BCO DE CREDITO E INV)", label: "BCI (BCO DE CREDITO E INV)" },
    { value: "COOPEUCH", label: "COOPEUCH" },
    { value: "HSBC BANK", label: "HSBC BANK" },
    { value: "ITAU CHILE", label: "ITAU CHILE" },
    { value: "ITAU-CORPBANCA", label: "ITAU-CORPBANCA" },
    { value: "SCOTIANBANK", label: "SCOTIANBANK" },
  ],
  CO: [
    { value: "Banco Agrario de Colombia", label: "Banco Agrario de Colombia" },
    { value: "Banco AV Villas", label: "Banco AV Villas" },
    { value: "Banco Caja Social", label: "Banco Caja Social" },
    { value: "Banco de Occidente (Colombia)", label: "Banco de Occidente (Colombia)" },
    { value: "Banco Popular (Colombia)", label: "Banco Popular (Colombia)" },
    { value: "Bancóldex", label: "Bancóldex" },
    { value: "Bancolombia", label: "Bancolombia" },
    { value: "BBVA (Colombia)", label: "BBVA (Colombia)" },
    { value: "Banco de Bogotá", label: "Banco de Bogotá" },
    { value: "CITI Colombia", label: "CITI Colombia" },
    { value: "Colpatria", label: "Colpatria" },
    { value: "Davivienda", label: "Davivienda" },
    { value: "GNB Sudameris", label: "GNB Sudameris" },
  ],
  EC: [
    { value: "Banco Central del Ecuador", label: "Banco Central del Ecuador" },
    { value: "Banco del Estado", label: "Banco del Estado" },
    { value: "Banco de Guayaquil", label: "Banco de Guayaquil" },
    { value: "Banco Pichincha", label: "Banco Pichincha" },
    { value: "Banco Internacional", label: "Banco Internacional" },
    { value: "Produbanco", label: "Produbanco" },
    { value: "Banco Bolivariano", label: "Banco Bolivariano" },
    { value: "Banco General Rumiñahui", label: "Banco General Rumiñahui" },
    { value: "Banco Promerica", label: "Banco Promerica" },
    { value: "Banco del Austro", label: "Banco del Austro" },
    { value: "Banco Cofise", label: "Banco Cofise" },
    { value: "Banco de Loja", label: "Banco de Loja" },
    { value: "Banco ProCredit", label: "Banco ProCredit" },
    { value: "Banco Finca", label: "Banco Finca" },
    { value: "Banco de la Producción", label: "Banco de la Producción" },
    { value: "Banco de Machala", label: "Banco de Machala" },
    { value: "Banco Solidario", label: "Banco Solidario" },
    { value: "Banco del Pacífico", label: "Banco del Pacífico" },
    { value: "Banco de la Nación", label: "Banco de la Nación" },
    { value: "Banco Continental", label: "Banco Continental" },
    { value: "Banco Popular", label: "Banco Popular" },
  ],
  PE: [
    { value: "Banco de Credito del Perú", label: "Banco de Credito del Perú" },
    {
      value: "Banco Internacional del Perú INTERBANK",
      label: "Banco Internacional del Perú INTERBANK",
    },
    { value: "Citibank del Perú S.A.", label: "Citibank del Perú S.A." },
    { value: "Scotiabank Perú S.A.A.", label: "Scotiabank Perú S.A.A." },
    { value: "BBVA Banco Continental", label: "BBVA Banco Continental" },
    { value: "Banco de la Nación", label: "Banco de la Nación" },
    { value: "Banco de Comercio", label: "Banco de Comercio" },
    { value: "Banco Pichincha", label: "Banco Pichincha" },
    { value: "Banco Interamericano de Finanzas", label: "Banco Interamericano de Finanzas" },
    { value: "CrediScotia Financiera S.A.", label: "CrediScotia Financiera S.A." },
    { value: "Mibanco Banco de la Microempresa", label: "Mibanco Banco de la Microempresa" },
    { value: "Banco GNB", label: "Banco GNB" },
    { value: "Banco Falabella Perú S.A.", label: "Banco Falabella Perú S.A." },
    { value: "Banco Ripley Perú", label: "Banco Ripley Perú" },
    { value: "Banco Santander Perú S.A.", label: "Banco Santander Perú S.A." },
    { value: "Banco Azteca del Perú S.A.", label: "Banco Azteca del Perú S.A." },
    { value: "Banco ICBC", label: "Banco ICBC" },
    { value: "Compartamos Financiera", label: "Compartamos Financiera" },
    {
      value: "Caja Municipal de Crédito Popular de Lima S.A.",
      label: "Caja Municipal de Crédito Popular de Lima S.A.",
    },
    { value: "CMAC Piura S.A.C.", label: "CMAC Piura S.A.C." },
    {
      value: "Caja Municipal de Ahorro y Crédito de Trujillo S.A.",
      label: "Caja Municipal de Ahorro y Crédito de Trujillo S.A.",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito de Arequipa",
      label: "Caja Municipal de Ahorro y Crédito de Arequipa",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito de Sullana",
      label: "Caja Municipal de Ahorro y Crédito de Sullana",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito de Cusco",
      label: "Caja Municipal de Ahorro y Crédito de Cusco",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito de Huancayo",
      label: "Caja Municipal de Ahorro y Crédito de Huancayo",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito de Ica",
      label: "Caja Municipal de Ahorro y Crédito de Ica",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito Maynas",
      label: "Caja Municipal de Ahorro y Crédito Maynas",
    },
    {
      value: "Caja Municipal de Ahorro y Crédito Tacna",
      label: "Caja Municipal de Ahorro y Crédito Tacna",
    },
  ],
  UY: [
    { value: "BANCO BANDES URUGUAY S.A.", label: "BANCO BANDES URUGUAY S.A." },
    {
      value: "BANCO BILBAO VIZCAYA ARGENTARIA URUGUAY S.A.",
      label: "BANCO BILBAO VIZCAYA ARGENTARIA URUGUAY S.A.",
    },
    {
      value: "BANCO DE LA NACIÓN ARGENTINA (Sucursal Uruguay)",
      label: "BANCO DE LA NACIÓN ARGENTINA (Sucursal Uruguay)",
    },
    { value: "BANCO ITAU URUGUAY S.A.", label: "BANCO ITAU URUGUAY S.A." },
    { value: "BANCO SANTANDER S.A.", label: "BANCO SANTANDER S.A." },
    { value: "BANQUE HERITAGE (URUGUAY) S.A.", label: "BANQUE HERITAGE (URUGUAY) S.A." },
    { value: "CITIBANK N.A. (Sucursal Uruguay)", label: "CITIBANK N.A. (Sucursal Uruguay)" },
    { value: "HSBC BANK (URUGUAY) S.A.", label: "HSBC BANK (URUGUAY) S.A." },
    { value: "SCOTIABANK URUGUAY S.A.", label: "SCOTIABANK URUGUAY S.A." },
  ],
};

export const DOCUMENTS_BY_COUNTRY: Record<string, { value: string; label: string }[]> = {
  AR: [{ value: "CUIT/CUIL", label: "CUIT/CUIL" }],
  BR: [{ value: "CPF", label: "CPF" }],
  CL: [{ value: "RUT", label: "RUT" }],
  CO: [
    { value: "C. Ciudadanía", label: "C. Ciudadanía" },
    { value: "NIT", label: "NIT" },
    { value: "C. Extranjería", label: "C. Extranjería" },
    { value: "Pasaporte", label: "Pasaporte" },
  ],
  EC: [
    { value: "DNI/CI", label: "DNI/CI" },
    { value: "RUC", label: "RUC" },
  ],
  PE: [{ value: "RUC", label: "RUC" }],
  UY: [
    { value: "RUT", label: "RUT" },
    { value: "Cédula de identidad", label: "Cédula de identidad" },
  ],
};

export const BASE_ACCOUNT_TYPES = [
  { value: "current", label: "Cuenta Corriente" },
  { value: "vista", label: "Cuenta Vista" },
];

export const ACCOUNT_TYPES_BY_COUNTRY: Record<string, { value: string; label: string }[]> = {
  AR: BASE_ACCOUNT_TYPES,
  BR: BASE_ACCOUNT_TYPES,
  CL: [{ value: "saving", label: "Cuenta de Ahorro" }, ...BASE_ACCOUNT_TYPES],
  CO: BASE_ACCOUNT_TYPES,
  EC: BASE_ACCOUNT_TYPES,
  PE: BASE_ACCOUNT_TYPES,
  UY: BASE_ACCOUNT_TYPES,
};
